"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonEditor = void 0;
const draftToHtml = require("draftjs-to-html");
const React = require("react");
const react_draft_wysiwyg_1 = require("react-draft-wysiwyg");
const html_to_draftjs_1 = require("html-to-draftjs");
const draft_js_1 = require("draft-js");
require("react-draft-wysiwyg/dist/react-draft-wysiwyg.css");
const editor_const_1 = require("./editor.const");
const BronsonEditor = ({ defaultValue, onChange, dropdown, toolbarHidden, removeOptions, removeSubOptions, readOnly, }) => {
    const [editorState, setEditorState] = React.useState(() => draft_js_1.EditorState.createEmpty());
    const [html, setHTML] = React.useState('');
    React.useEffect(() => {
        if (!!defaultValue) {
            if (defaultValue !== html) {
                const blocksFromHtml = (0, html_to_draftjs_1.default)(defaultValue);
                const { contentBlocks, entityMap } = blocksFromHtml;
                const contentState = draft_js_1.ContentState.createFromBlockArray(contentBlocks, entityMap);
                const defaultContent = draft_js_1.EditorState.createWithContent(contentState);
                setEditorState(defaultContent);
                setHTML('');
            }
        }
        else {
            setEditorState(() => draft_js_1.EditorState.createEmpty());
        }
    }, [defaultValue]);
    const onEditorChange = (content) => {
        setEditorState(content);
        const htmlContent = draftToHtml((0, draft_js_1.convertToRaw)(content.getCurrentContent()));
        setHTML(htmlContent);
        onChange(htmlContent);
    };
    const getOptions = (defaultOptions, deleteOptions) => {
        return defaultOptions.filter((option) => deleteOptions ? !deleteOptions.includes(option) : defaultOptions);
    };
    const getRemoveOptions = (subOption) => {
        return removeSubOptions ? removeSubOptions[subOption] : [];
    };
    const getToolbar = () => {
        let toolBar;
        editor_const_1.sections.forEach((option) => {
            toolBar = Object.assign(Object.assign({}, toolBar), { [option]: {
                    inDropdown: dropdown && dropdown[option],
                    options: getOptions(editor_const_1.allOptions[option], getRemoveOptions(option)),
                } });
        });
        return toolBar;
    };
    const toolbar = getToolbar();
    return (React.createElement("div", { className: 'u-border u-p-small' },
        React.createElement(react_draft_wysiwyg_1.Editor, { editorState: editorState, readOnly: readOnly, toolbarHidden: !!readOnly ? readOnly : toolbarHidden, toolbar: Object.assign({ options: getOptions(editor_const_1.availableEditorOptions, removeOptions) }, toolbar), onEditorStateChange: onEditorChange })));
};
exports.BronsonEditor = BronsonEditor;
